import { ReceiptSource } from "./receiptPdf";

/** A receipt offer made right after money was recorded. */
export type ReceiptOffer = { source: ReceiptSource; message?: string };

let host: ((offer: ReceiptOffer) => void) | null = null;

/** Mounted once (ReceiptPromptHost); returns the unregister cleanup. */
export const registerReceiptPrompt = (handler: (offer: ReceiptOffer) => void) => {
	host = handler;
	return () => {
		if (host === handler) host = null;
	};
};

/**
 * Offer a receipt after a payment / wallet movement was saved. The host
 * applies the user's permission and the UI_PRINT_RECEIPT setting, so the
 * modals that record money only need to say what was saved. They close
 * themselves on success, which is why the dialog lives in the host.
 */
export const offerReceipt = (offer: ReceiptOffer) => {
	host?.(offer);
};
